@use "variables" as *;

.appBar {
  height: $appBarHeight;
}

.toolbar {
  padding-left: $spacing-s;
  padding-right: $spacing-s;
}

.piperLogo {
  margin-right: $spacing-s !important;
}

.mainBody {
  display: flex;
  min-height: calc(100% - #{$appBarHeight});
}

.albumListContainer {
  display: flex;
}

.layoutDetail {
  padding-top: $spacing-m;
  padding-right: $spacing-m;
  padding-bottom: $spacing-m;
  overflow: hidden !important;
}

.collectionTitle {
  font-size: $fontSize-ml;
  font-weight: bold;
  text-transform: none !important;
  text-align: left;
  padding-left: $spacing-s;
  padding-right: $spacing-s;
}

.collectionTitleText {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.resizeHandle {
  width: $spacing-m;
  display: flex;
  justify-content: center;
  outline: none !important;
}

.toolbarIcon {
  font-size: $fontSize-l !important;
}

.searchBar {
  margin-left: 0;
}

.loadingIndicator {
  width: 20px !important;
  height: 20px !important;
  margin-right: $spacing-s;
  margin-left: $spacing-m;
}

.mobileCloseButton {
  width: 42px;
}

.cancelButton {
  margin-right: $spacing-m !important;
  margin-left: $spacing-m !important;
}

.expandIcon {
  font-size: $fontSize-l !important;
}
